<template>
    <v-container fluid>
        <v-layout justify-center>
            <v-container grid-list-md>
                <navigation-cards/>
            </v-container>
        </v-layout>
    </v-container>
</template>

<script>
    import NavigationCards from "../components/dashboard/NavigationCards";

    export default {
        components: {
            "navigation-cards": NavigationCards,
        },
    }
</script>
